import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// ErrorBoundary를 쓰고 있다면 유지
import ErrorBoundary from "./components/ErrorBoundary";

// ═══════════════════════════════════════════════════════
// 🔑 axios 전역 토큰 자동첨부 (2026 추가)
//
//  왜 필요한가:
//    - src/api/axios.js, http.js 에는 interceptor 가 있지만
//      `import axios from "axios"` 로 직접 쓰는 파일들
//      (BuildingSearchPage.jsx, Header.jsx 등)에는 토큰이 안 붙음
//    - 백엔드에 등급검사(authJwtMw)를 걸면 그 파일들이 401 을 받게 됨
//
//  동작:
//    - 모든 axios 요청 직전에 localStorage 의 token 을 헤더에 붙임
//    - 토큰이 없으면(비로그인) 아무것도 안 붙임 → 기존 공개 API 는 그대로 동작
//
//  연관 파일:
//    - backend/middleware/authJwt.js  (이 헤더를 읽어 req.user 를 채움)
//    - backend/server.js 106줄 authJwtMw / requireGrade
// ═══════════════════════════════════════════════════════
import axios from "axios";
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ═══════════════════════════════════════════════════════
// 🔑 fetch 전역 토큰 자동첨부 (2026 추가)
//
//  왜 필요한가:
//    - 위 axios interceptor 는 axios 요청에만 적용됨
//    - 매물 목록(api/propertyApi.js), 사진, 썸네일 등 상당수가
//      fetch() 를 직접 사용 → 토큰이 안 붙어 서버가 "비로그인"으로 판단
//    - 그 결과 관리자도 연락처·호수가 가려지는 문제 발생
//
//  동작:
//    - 원래 fetch 를 보관해 두고, 감싼 함수로 교체
//    - 주소에 "/api/" 가 있을 때만 토큰 첨부
//      → 카카오맵 등 외부 요청에는 우리 토큰이 새어나가지 않음
//    - 호출하는 쪽에서 이미 Authorization 을 넣었다면 그대로 존중
//
//  연관 파일:
//    - api/propertyApi.js  (fetch 로 /api/properties 호출)
//    - backend/routes/properties.js  softAuth (이 헤더를 읽어 등급 판별)
// ═══════════════════════════════════════════════════════
const _origFetch = window.fetch.bind(window);
window.fetch = (input, init = {}) => {
  try {
    // input 은 문자열일 수도, Request 객체일 수도 있음
    const urlStr = typeof input === "string" ? input : (input?.url || "");
    if (urlStr.includes("/api/")) {
      const token = localStorage.getItem("token");
      // 기존 헤더를 보존하면서 Authorization 만 추가
      const headers = new Headers(init.headers || {});
      if (token && !headers.has("Authorization")) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      init = { ...init, headers };
    }
  } catch (e) {
    // 어떤 이유로든 실패해도 원래 요청은 그대로 진행 (화면이 멈추지 않도록)
    console.warn("[fetch wrapper]", e.message);
  }
  return _origFetch(input, init);
};

if (process.env.NODE_ENV === 'production') {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(rs => rs.forEach(r => r.unregister()));
  }
  if (window.caches) {
    caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // StrictMode 제거 (이중 마운트로 인한 타이밍/TDZ 이슈 방지)
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
